import { render, staticRenderFns } from "./ThgChargingStationProofChipList.vue?vue&type=template&id=60a937a7"
import script from "./ThgChargingStationProofChipList.vue?vue&type=script&lang=ts"
export * from "./ThgChargingStationProofChipList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports